import React, { createContext, useState } from 'react';

export const GameSettingsContext = createContext();

export const GameSettingsProvider = ({ children }) => {
  const [timerDuration, setTimerDuration] = useState(60); 
  const [isSoundEnabled, setIsSoundEnabled] = useState(true);

  return (
    <GameSettingsContext.Provider value={{ timerDuration, setTimerDuration, isSoundEnabled, setIsSoundEnabled }}>
      {children}
    </GameSettingsContext.Provider>
  );
};
